<div class="dialog-header">
	<div class="header-title">
		<span style="font-size: 120%;">Edit Service Order Items</span>
	</div>

	<button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
		<mat-icon>clear</mat-icon>
	</button>
</div>


<div class="edit-block">
	<form #userEditForm="ngForm">
		<div class="form-block">
			<div class="form-row">
				<ng-container *ngIf="!showItems">
					<lib-progress-spinner></lib-progress-spinner>
				</ng-container>

				<p-listbox [options]="shortItems" [(ngModel)]="selectedShortItems" [multiple]="true"
					class="p-list-box-block" [checkbox]="true" [filter]="true" optionLabel="name"
					[ngModelOptions]="{standalone: true}" [required]="true" *ngIf="showItems">
					<p-header>
						{{projectName ? projectName : 'Punch Items'}}
					</p-header>

					<ng-template let-item let-i="index" pTemplate="item">
						<div class="ui-helper-clearfix" [ngClass]="{'ready-punch-item': shortItems[i].ready}">
							<div class="mat-block-name">{{shortItems[i].name}}</div>
							<div class="completed-title" *ngIf="shortItems[i].ready">COMPLETED</div>
						</div>
					</ng-template>
				</p-listbox>

			</div>

		</div>

		<div class="save-btn-block">

			<button mat-button class="save-btn" (click)="saveOrder()" [disabled]="loadingSpinner" tabindex="1"
				type="submit" [ngClass]="{'disabled-button': loadingSpinner}">

				<span *ngIf="!loadingSpinner">Save</span>
				<lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
			</button>
		</div>
	</form>

</div>